import React from "react";
import "./QuizFilters.scss";
import { QUIZ_CATEGORIES, QuizSubCategory } from "../../models/quizCategory";
import { QuizFiltersProps } from "./QuizFilters.d";

const QuizFilters = ({
  onSelectCategory,
  onSelectSubCategory,
  selectedCategory,
  selectedSubCategory,
}: QuizFiltersProps) => {
  return (
    <div
      className="p-3 p-md-4 rounded-plus shadow-sm bg-white sticky-top sticky-offset"
      id="quiz-filters"
    >
      <h4 className="mb-3">Filtres</h4>
      <p className="text-muted font-s mb-3 mb-md-4">
        Testez gratuitement vos connaissances à l’aide de nos quiz métiers
        rapides.
      </p>

      <div className="d-flex align-items-center">
        <span
          className={`fw-semibold clickable py-3 w-100 ${
            selectedCategory === null ? "text-navy-light" : ""
          }`}
          onClick={() => {
            onSelectCategory(null);
            onSelectSubCategory(null);
          }}
        >
          Tous les quiz
        </span>
      </div>

      <hr className="text-muted my-0" />

      {Object.values(QUIZ_CATEGORIES).map((category) => {
        const isOpen = selectedCategory === category.id;
        return (
          <div key={category.id}>
            <div
              className="d-flex justify-content-between align-items-center clickable py-3"
              onClick={() => {
                onSelectCategory(category.id);
                onSelectSubCategory(null);
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <span
                  className="ellipse"
                  style={{ backgroundColor: category.color }}
                />
                <span
                  className={`fw-semibold ${isOpen ? "text-navy-light" : ""}`}
                >
                  {category.label}
                </span>
              </div>
              <span
                className={`${
                  isOpen ? "dst-icon-chevron-up" : "dst-icon-chevron-down"
                }`}
              />
            </div>
            {isOpen && (
              <div className="ps-3 ps-md-4 pb-2">
                {Object.values(QuizSubCategory).map((subcategory) => (
                  <div
                    key={subcategory}
                    className="clickable py-1"
                    onClick={() => onSelectSubCategory(subcategory)}
                  >
                    <span
                      className={`font-s ${
                        selectedSubCategory === subcategory
                          ? "text-navy-light"
                          : ""
                      }`}
                    >
                      {subcategory}
                    </span>
                  </div>
                ))}
              </div>
            )}
            <hr className="text-muted my-0" />
          </div>
        );
      })}
    </div>
  );
};

export default QuizFilters;
